import { cva } from 'class-variance-authority'

export const sheetVariants = cva(
  `
  fixed
  z-1000
  gap-4
  bg-neutral-0
  p-4 sm:p-10
  shadow-md
  transform
  transition-transform
  duration-500
  ease-in-out
  text-neutral-600
  overflow-y-auto
  h-full
  max-h-screen
  overscroll-contain
  data-[state=closed]:duration-300
  data-[state=open]:duration-500
  data-[state=open]:animate-in
  data-[state=closed]:animate-out
  `,
  {
    variants: {
      side: {
        top: `
          inset-x-0
          top-0
          border-b-neutral-200
          data-[state=closed]:slide-out-to-top
          data-[state=open]:slide-in-from-top
        `,
        bottom: `
          inset-x-0
          bottom-0
          border-t-neutral-200
          data-[state=closed]:slide-out-to-bottom
          data-[state=open]:slide-in-from-bottom
        `,
        left: `
          inset-y-0
          left-0
          h-full
          w-full
          sm:w-3/4
          lg:w-[500px]
          border-r
          border-r-neutral-200
          data-[state=closed]:slide-out-to-left
          data-[state=open]:slide-in-from-left
        `,
        right: `
          inset-y-0
          right-0
          h-full
          w-full
          sm:w-3/4
          lg:w-[500px]
          border-l
          border-l-neutral-200
          data-[state=closed]:slide-out-to-right
          data-[state=open]:slide-in-from-right
        `,
      },
    },
    defaultVariants: {
      side: 'right',
    },
  }
)

export const overlayStyles = `
  fixed
  inset-0
  z-50
  bg-black/80
  data-[state=open]:animate-in
  data-[state=closed]:animate-out
  data-[state=closed]:fade-out-0
  data-[state=open]:fade-in-0
`

export const closeButtonStyles = `
  absolute
  top-2 right-2
  sm:top-4 sm:right-4
  p-2
  rounded-sm
  opacity-70
  ring-offset-background
  transition-opacity
  hover:opacity-100
  focus:outline-none
  focus:ring-2
  focus:ring-ring
  focus:ring-offset-2
  disabled:pointer-events-none
  data-[state=open]:bg-secondary
`

export const closeButtonIconStyles = `
  h-4
  w-4
`

export const footerStyles = `
  flex
  flex-col-reverse
  sm:flex-row
  sm:justify-end
  sm:space-x-2
  pt-4
`

export const titleStyles = `
  h1
  text-neutral-900
  !mt-0
`

export const descriptionStyles = `
  text-sm
  text-muted-foreground
`
